import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type SkillPillFragment = { id: string, name: string };


export type SkillPillFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SkillPillFragmentDoc = /*#__PURE__*/ gql`
    fragment SkillPill on SkillType {
  id
  name
}
    `;